import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useReducer, useEffect } from 'react';
import invariant from 'invariant';
import classnames from 'classnames';
import Button from '../../button';
import Page from '../page';
import { calcNamePath } from '../../utils/form-utils';
import FormContext from '../../form-context';
import { LocaleContext } from '../../locale';
import Typography from '../../typography';
import './style/index.less';
var useBreakpoint = _Grid.useBreakpoint;

var Pages = function Pages(_ref) {
  var parentName = _ref.parentName,
      _ref$config = _ref.config,
      name = _ref$config.name,
      _ref$config$elements = _ref$config.elements,
      elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
      subscribedFields = _ref$config.subscribedFields,
      className = _ref$config.className;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var _useReducer = useReducer(function (r) {
    return r + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var _useContext2 = useContext(FormContext),
      form = _useContext2.form,
      submitText = _useContext2.submitText,
      previewText = _useContext2.previewText,
      nextText = _useContext2.nextText,
      submitting = _useContext2.submitting,
      showSubmitButton = _useContext2.showSubmitButton,
      registerDependencies = _useContext2.registerDependencies;

  useEffect(function () {
    var subscribe = elements.some(function (_ref2) {
      var shouldRender = _ref2.shouldRender,
          getButtonDisabledState = _ref2.getButtonDisabledState,
          getPreviousDisabledState = _ref2.getPreviousDisabledState;
      return Boolean(shouldRender) || Boolean(getButtonDisabledState) || Boolean(getPreviousDisabledState);
    });

    if (subscribe) {
      Array.isArray(subscribedFields) ? registerDependencies(subscribedFields, dispatch) : registerDependencies('SUBSCRIBE_ALL', dispatch);
    }
  }, []);

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var renderElements = elements.filter(function (page) {
    return typeof page.shouldRender !== 'function' || page.shouldRender(form);
  });

  var handleNext = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _allFields$filter;

      var allFields, _renderElements$curre, currentName, handleNext, namePath, fields, errors;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allFields = (form === null || form === void 0 ? void 0 : form.getFieldsError()) || [];
              _renderElements$curre = renderElements[current], currentName = _renderElements$curre.name, handleNext = _renderElements$curre.handleNext;
              namePath = calcNamePath(name, currentName);
              fields = allFields === null || allFields === void 0 ? void 0 : (_allFields$filter = allFields.filter(function (_ref4) {
                var name = _ref4.name;
                return name.join().startsWith(namePath === null || namePath === void 0 ? void 0 : namePath.join());
              })) === null || _allFields$filter === void 0 ? void 0 : _allFields$filter.map(function (_ref5) {
                var name = _ref5.name;
                return name;
              });
              _context.prev = 4;
              _context.next = 7;
              return form === null || form === void 0 ? void 0 : form.validateFields(fields);

            case 7:
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](4);
              form === null || form === void 0 ? void 0 : form.scrollToField(_context.t0.errorFields[0].name);
              return _context.abrupt("return");

            case 13:
              if (!(typeof handleNext === 'function')) {
                _context.next = 25;
                break;
              }

              _context.prev = 14;
              _context.next = 17;
              return handleNext(form === null || form === void 0 ? void 0 : form.getFieldsValue(fields));

            case 17:
              errors = _context.sent;

              if (!Array.isArray(errors)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", form === null || form === void 0 ? void 0 : form.setFields(errors));

            case 20:
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](14);
              return _context.abrupt("return");

            case 25:
              setCurrent(current + 1);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 9], [14, 22]]);
    }));

    return function handleNext() {
      return _ref3.apply(this, arguments);
    };
  }();

  var _renderElements$curre2 = renderElements[current],
      getButtonDisabledState = _renderElements$curre2.getButtonDisabledState,
      getPreviousDisabledState = _renderElements$curre2.getPreviousDisabledState;
  var buttonDisabled = getButtonDisabledState && form && getButtonDisabledState(form);
  var previousDisabled = getPreviousDisabledState && form && getPreviousDisabledState(form);
  return _jsxs("div", {
    className: classnames('igloo-pages-container', className),
    children: [_jsx(Typography, {
      className: "igloo-pages-page-title",
      level: md ? 'h3b' : 'body1',
      wrapElement: "div",
      style: {
        padding: md ? 0 : '0 16px'
      },
      children: renderElements[current].label
    }), _jsxs("div", {
      className: 'igloo-pages-content',
      children: [renderElements.map(function (child, index) {
        invariant(child.type === 'Page', 'Child of Pages should be Page');
        return _jsx("div", {
          className: 'igloo-pages-page',
          style: current === index ? {
            display: 'block'
          } : {
            display: 'none'
          },
          children: _jsx(Page, {
            config: child,
            parentName: calcNamePath(parentName, name),
            showFooter: false
          })
        }, child.key || child.name);
      }), _jsxs("div", {
        className: 'igloo-pages-footer',
        children: [current === 0 && _jsx("div", {}), current > 0 && _jsx(Button, {
          className: 'igloo-pages-preview-button',
          onClick: function onClick() {
            return setCurrent(current - 1);
          },
          disabled: previousDisabled,
          children: previewText || formatMessage({
            id: 'Previous'
          })
        }), current < renderElements.length - 1 && _jsx(Button, {
          className: 'igloo-pages-next-button',
          onClick: handleNext,
          disabled: buttonDisabled,
          type: "primary",
          children: nextText || formatMessage({
            id: 'Next'
          })
        }), current === renderElements.length - 1 && showSubmitButton && _jsx(_Form.Item, {
          children: _jsx(Button, {
            type: "primary",
            htmlType: "submit",
            className: 'igloo-pages-submit-button',
            loading: submitting,
            disabled: buttonDisabled,
            children: submitText || formatMessage({
              id: 'Submit'
            })
          })
        })]
      })]
    })]
  });
};

export default Pages;